import { FC } from 'react';
import ReportMetricCardSkeleton from './primitives/ReportMetricCardSkeleton';
import ReportMetricCard from './ReportMetricCard';

interface ReportMetricCardsRowItem {
  title: string;
  value: string;
  badge?: number;
  caption?: string;
  platformPageTypes?: number[];
}

interface ReportMetricCardsRowProps {
  isLoading: boolean;
  skeletonCount: number;
  gridClassName: string;
  items?: ReportMetricCardsRowItem[];
  skeletonWithPlatformRow?: boolean;
}

const ReportMetricCardsRow: FC<ReportMetricCardsRowProps> = ({
  isLoading,
  skeletonCount,
  gridClassName,
  items,
  skeletonWithPlatformRow = false,
}) => {
  return (
    <section
      className={`${gridClassName} analytics-report-metric-cards-row tw-gap-1`}
    >
      {isLoading ? (
        <>
          {Array.from({ length: skeletonCount }, (_, index) => (
            <ReportMetricCardSkeleton
              key={index}
              className="tw-border tw-border-grayscale-20"
              withPlatformRow={skeletonWithPlatformRow}
            />
          ))}
        </>
      ) : (
        <>
          {items?.map((item, index) => (
            <ReportMetricCard
              key={`${index}-${item.title}`}
              title={item.title}
              value={item.value}
              badge={item.badge}
              caption={item.caption}
              platformPageTypes={item.platformPageTypes}
            />
          ))}
        </>
      )}
    </section>
  );
};

export default ReportMetricCardsRow;
